const alertBox = (value) => {
    return dispatch => {
        dispatch({ type: 'SET_EVALUATION', text: value.text, icon: value.icon });
    }
}
export { alertBox }